<div
  class="flex shrink items-center justify-end border-t px-8 py-5 bg-gray-50 dark:bg-gray-700"
>
  <ng-content></ng-content>
</div>
